module.exports = __webpack_public_path__ + "media/img/agents_bg-f997e97643210e1cc3bf582883761694.png";